import { CSSProperties } from 'react';

interface PropsType {
  style?: CSSProperties;
  color?: string;
}

const SvgIconChatBalloon = (props: PropsType) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style ? props.style : undefined}
    >
      <g mask='url(#mask0_1235_3833)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.06006 1.53342C3.30311 0.575982 4.99533 0 6.83813 0C10.4631 0 13.6688 2.28916 13.6688 5.40205C13.6688 8.17243 11.1075 10.288 8.01806 10.7548L6.53549 12.4958C6.41933 12.6344 6.26612 12.737 6.09375 12.7917C5.92013 12.8468 5.73436 12.8509 5.55846 12.8036C5.38255 12.7563 5.2239 12.6596 5.1013 12.5249C4.97942 12.391 4.89826 12.2251 4.86731 12.0467L4.58941 10.5002C2.00075 9.79852 0 7.87474 0 5.40205C0 3.85388 0.816357 2.49137 2.06006 1.53342Z'
          fill={props.color ? props.color : '#E4E4E4'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.8005 7.59204C11.8692 7.29158 12.1684 7.10368 12.4689 7.17236C14.4388 7.62261 15.998 9.04944 15.998 10.849C15.998 12.5239 14.6443 13.8775 12.9498 14.3985L12.7826 15.3206C12.7561 15.475 12.6857 15.6186 12.58 15.7342C12.4729 15.8513 12.3341 15.9347 12.1805 15.9744C12.0269 16.014 11.8651 16.0081 11.7147 15.9575C11.5673 15.9079 11.4372 15.8173 11.3395 15.6965L10.4032 14.5729C8.44609 14.269 6.75415 12.8864 6.53717 11.0638C6.50074 10.7577 6.7193 10.4801 7.02535 10.4436C7.3314 10.4072 7.60904 10.6258 7.64547 10.9318C7.79216 12.164 9.0562 13.3052 10.7543 13.4939C10.8976 13.5098 11.0291 13.5805 11.1214 13.6913L11.7968 14.5017L11.9145 13.8523C11.9542 13.633 12.1206 13.4584 12.3378 13.4081C13.8868 13.0496 14.8819 11.9439 14.8819 10.849C14.8819 9.76147 13.8963 8.64354 12.2202 8.26042C11.9197 8.19174 11.7318 7.8925 11.8005 7.59204ZM12.2095 14.9973L12.2046 14.9913C12.2063 14.9933 12.2079 14.9953 12.2095 14.9973Z'
          fill={props.color ? props.color : '#E4E4E4'}
        />
      </g>
    </svg>
  );
};

export default SvgIconChatBalloon;
